import type React from 'react';

export default function RenderChildren<Type>(
	children: React.ReactNode | ((props: Type) => React.ReactNode),
	props: Type,
) {
	// Check if the component got 'function as child' more than once
	if (Array.isArray(children)) {
		const countFunctions = children.reduce(
			(accumulator: number, child: React.ReactNode) =>
				typeof child === 'function' ? (accumulator += 1) : accumulator,
			0,
		);
		if (countFunctions > 1) {
			throw new Error(`Component expected 1 function as child but got ${countFunctions}.`);
		}
	}
	return typeof children === 'function' ? children(props) : children;
}
